import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'
// import Img from 'gatsby-image'
import { rem, media, CAREER_URL } from '../../utils'

import facebook from '../../images/facebook.svg'
import instagram from '../../images/instagram.svg'
import linkedIn from '../../images/linkedIn.svg'
import pinterest from '../../images/pinterest.svg'
import twitter from '../../images/twitter.svg'
import hiringBubble from '../../images/hiringBubble.svg'
import setterLogomark from '../../images/setterLogomark.svg'

export default props => {
  const { footerSections } = props

  return (
    <Footer>
      <Social>
        <div className="hiring">
          <div className="logo">
            <Link to="/">
              <img srcSet={setterLogomark} alt="" />
            </Link>
            <a className="hiringBubble" href={`${CAREER_URL}`}>
              <img srcSet={hiringBubble} alt="" />
            </a>
          </div>
        </div>
        <div className="social">
          {socialLinks.map(({ id, href, src }) => (
            <a key={id} href={href}>
              <img srcSet={src} alt="" />
            </a>
          ))}
        </div>
        <div className="email">
          Email us at
          <a href="mailto:hello@setter.com">hello@setter.com</a>
        </div>
      </Social>

      {footerSections.map(({ id, footerLinks }) => (
        <Links
          key={id}
          dangerouslySetInnerHTML={{
            __html: footerLinks.childMarkdownRemark.html,
          }}
        />
      ))}
    </Footer>
  )
}

const socialLinks = [
  {
    id: 1,
    href: ' https://www.instagram.com/setterhome/',
    src: instagram,
  },
  {
    id: 2,
    href: ' https://facebook.com/hellosetter',
    src: facebook,
  },
  {
    id: 3,
    href: 'https://www.pinterest.ca/setterhome',
    src: pinterest,
  },
  {
    id: 4,
    href: ' https://www.linkedin.com/company/setter-home-services',
    src: linkedIn,
  },
  {
    id: 5,
    href: 'https://twitter.com/meetsetter',
    src: twitter,
  },
]

const Social = styled.div`
  div {
    display: flex;
  }

  .hiring {
    display: flex;
    flex-direction: column;

    .logo {
      display: flex;
      align-items: center;

      .hiringBubble {
        margin-left: ${rem(10)};
      }
    }
  }
  .social {
    margin-top: ${rem(10)};
    a {
      margin-left: ${rem(10)};

      &:first-child {
        margin-left: 0;
      }
    }
  }

  .email {
    margin-top: ${rem(10)};
    font-size: ${rem(12)};
    a {
      font-size: ${rem(12)};
      color: ${({ theme }) => theme.color.font};
      display: inline-block;
      font-family: 'Basis Bold';
      letter-spacing: normal;
      margin-left: ${rem(5)};
    }
  }
`

const Links = styled.div`
  color: #344e63;
  margin-top: ${rem(40)};

  ${media.tablet`
      margin: 0;
      margin-left: ${rem(30)};
      max-width: ${rem(200)};
  `};

  ${media.desktop`
    margin-left: ${rem(65)};
  `};

  &:first-child {
    margin-top: 0;
  }

  &:last-child {
    a {
      margin-top: ${rem(5)};
    }
  }

  h1,
  h2,
  h3 {
    font-family: 'Basis Bold';
    font-size: ${rem(14)};
  }

  h5 {
    margin-top: ${rem(30)};
  }

  a {
    display: block;
    margin-top: ${rem(12)};
    color: #344e63;
    font-size: ${rem(14)};
    line-height: 22px;
    letter-spacing: normal;

    ${media.tablet`
    &:hover {
      /* font-family: 'Basis Bold'; */
      color: #ff4856;
      }
    `};
  }
`

const Footer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: #d2e0e4;
  padding: ${rem(60)};

  ${media.tablet`
    flex-direction: row;
    
  `};
`
